<template>
  <v-container fluid>
    <v-dialog v-model="bulletinDetailDialog" width="600px" persistent>
      <v-card>
        <v-card-title class="justify-start text-h5 grey lighten-2">
          <span class="text-h5">{{ bulletinDetail.newsTitle }}</span>
        </v-card-title>
        <v-card-text class="text-h6 text-start mt-3">
          {{ bulletinDetail.newsStory }}
        </v-card-text>
        <v-card-text class="caption text-start">
          - {{ bulletinDetail.newsAuthor }} <br />
          - {{ formatDate(bulletinDetail.createdAt) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="bulletinDetailDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <!-- <v-card tile class="mx-auto">
        <v-img
          position="bottom"
          class="white--text"
          height="70px"
          src="@/assets/card-bg.jpg"
        >
          <v-card-text class="text-right text-h6 font-weight-black">
            BULLETIN LIST
          </v-card-text>
        </v-img>
      </v-card> -->

      <v-data-table
        dense
        :headers="headers"
        :items="bulletins"
        :search="search"
        class="elevation-1"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [10, 20, 30, 40, 50, 100, -1],
        }"
        :items-per-page="50"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on: dialog, attrs }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      fab
                      small
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="{ ...tooltip, ...dialog }"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>ADD BULLETIN</span>
                </v-tooltip>
              </template>

              <v-card>
                <v-card-title class="justify-center text-h5 grey lighten-2">
                  <span>{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.newsTitle"
                          label="Title"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          v-model="editedItem.newsStory"
                          label="Content"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn outlined small tile @click="close"> Cancel </v-btn>
                  <v-btn
                    :disabled="isAddButtonDisabled"
                    small
                    tile
                    class="success"
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-divider class="mx-4" inset vertical></v-divider>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="justify-center text-h5 grey lighten-2"
                  >Confirm delete?
                  <!-- {{ editedItem.newsTitle }}? -->
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn outlined small tile @click="closeDelete">No</v-btn>
                  <v-btn small tile class="error" @click="deleteItemConfirm"
                    >Yes</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-toolbar>
        </template>

        <template slot="item.numbering" slot-scope="props">
          {{ props.index + 1 }}
        </template>

        <!-- Trick to truncate text and show elipsis at the end  -->
        <template v-slot:[`item.newsStory`]="{ value }">
          <div class="d-inline-block text-truncate" style="max-width: 300px">
            {{ value }}
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip left transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="mr-2"
                @click="showDetail(item)"
              >
                mdi-folder-open-outline
              </v-icon>
            </template>
            <span> Show Detail</span>
          </v-tooltip>

          <v-tooltip left transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span> edit</span>
          </v-tooltip>
          <v-tooltip right transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
                color="red darken-1"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span> delete</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import BulletinDataService from "../../services/BulletinDataService";
import moment from "moment";

export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    bulletinDetailDialog: false,
    bulletinDetail: false,
    bulletins: [],
    search: "",
    defaultItem: {
      id: null,
      newsTitle: "",
      newsStory: "",
      newsAuthor: "",
    },
    editedIndex: -1,
    editedItem: {
      id: null,
      newsTitle: "",
      newsStory: "",
      newsAuthor: "",
    },
    headers: [
      {
        text: "NO.",
        align: "start",
        sortable: false,
        value: "numbering",
      },
      {
        text: "TITLE",
        align: "start",
        sortable: true,
        value: "newsTitle",
      },
      {
        text: "CONTENT",
        align: "center",
        value: "newsStory",
        sortable: true,
      },
      {
        text: "AUTHOR",
        align: "center",
        value: "newsAuthor",
        sortable: true,
      },
      {
        text: "ACTIONS",
        align: "center",
        value: "actions",
        sortable: false,
      },
    ],
  }),

  computed: {
    currentUserName() {
      return this.$store.state.auth.user.username;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add Bulletin" : "Update Bulletin";
    },
    isAddButtonDisabled() {
      return !(this.editedItem.newsTitle && this.editedItem.newsStory);
    },

    // newsAuthor: {
    //   get() {
    //     return this.$store.state.auth.user.username;
    //   },
    //   set(val) {
    //     this.editedItem.newsAuthor = val;
    //   },
    // },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    formatDate(value) {
      if (!value) return "";
      return moment(value).format("DD/MM/YYYY");
    },
    showDetail(item) {
      this.bulletinDetail = Object.assign({}, item);
      this.bulletinDetailDialog = true;
    },

    retrieveBulletins() {
      BulletinDataService.getAll()
        .then((response) => {
          // this.bulletins = response.data.map(this.getDisplayBulletin);
          this.bulletins = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveUserName() {
      this.currentUserName()
        .then((response) => {
          this.editedItem.newsAuthor = response.data;
          // console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    refreshList() {
      this.retrieveBulletins();
    },

    getDisplayBulletin(bulletin) {
      return {
        id: bulletin.id,
        newsTitle:
          bulletin.newsTitle.length > 30
            ? bulletin.newsTitle.substr(0, 30) + "..."
            : bulletin.newsTitle,
        newsStory:
          bulletin.newsStory.length > 30
            ? bulletin.newsStory.substr(0, 30) + "..."
            : bulletin.newsStory,
        newsAuthor:
          bulletin.newsAuthor.length > 30
            ? bulletin.newsAuthor.substr(0, 30) + "..."
            : bulletin.newsAuthor,
      };
    },

    editItem(item) {
      this.editedIndex = this.bulletins.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.bulletins.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      BulletinDataService.delete(this.editedItem.id)
        .then((response) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "error",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });

          this.refreshList();
        })
        .catch((e) => {
          console.log(e);
        });

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        BulletinDataService.update(this.editedItem.id, this.editedItem)
          .then((response) => {
            this.close();
            this.$store.dispatch("setSnackbar", {
              showing: true,
              color: "warning",
              text:
                (response && response.data && response.data.message) ||
                toString(),
            });
            this.refreshList();
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        var data = {
          newsTitle: this.editedItem.newsTitle,
          newsStory: this.editedItem.newsStory,
          newsAuthor: this.$store.state.auth.user.username,
        };

        BulletinDataService.create(data)
          .then((response) => {
            this.editedItem.id = response.data.id;
            this.close();
            this.$store.dispatch("setSnackbar", {
              showing: true,
              color: "success",
              text:
                (response && response.data && response.data.message) ||
                toString(),
            });
            this.refreshList();
          })
          .catch((e) => {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text:
                (e.response && e.response.data && e.response.data.message) ||
                e.message ||
                toString(),
            });
          });
      }
      this.close();
    },
  },
  mounted() {
    this.retrieveBulletins();
  },
};
</script>
